import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import moment from 'moment';
import get from 'lodash/get';
import find from 'lodash/find';

import { navigate } from '../../../actions';
import {
  offerOrderAmountPath,
  offerOrderTransferPath,
  baseOfferOrderPath,
  offerOrderDisclosuresPath,
} from '../../Forms/Schemas/baseRrf';
import BaseConfirmationScreen from '../../BaseConfirmationScreen';
import LabeledRow from '../components/LabeledRow';
import { formatCurrency } from '../../Currency';
import { formatQuantity } from '../..//SecurityDetail/SecurityDetail';

import './styles.css';


const Component = ({
  bankLinks,
  investmentInfo,
  navigateTo,
  user,
  offer,
  offerOrderAmount,
  offerOrderTransferFunds,
  history,
  resetAll,
}) => {
  const { isConditional } = offer;
  // Navigate to history when pressing browser back button
  window.onpopstate = () => {
    resetAll();
    history.replace('/history');
  };

  // redirect to amount if there's no requested dollar amount
  // or if the offer hasn't been subscribed
  if (!offerOrderAmount.requestedDollarAmount || !investmentInfo.subscribed) {
    navigateTo(`/invest/${offer.id}/amount`);
    return null;
  }

  const transferBank = find(bankLinks, { bankLinkOid: offerOrderTransferFunds.from });

  let transferDetails;
  if (offerOrderTransferFunds.transferAmount) {
    transferDetails = (
      <div>
        <div styleName="breakLine" />
        <div styleName="transferDetailsLabel">Transfer Details</div>
        <LabeledRow
          label="From"
          value={transferBank.bankName}
          modifiedStyle="addressRow"
        />
        <LabeledRow
          label=""
          value={transferBank.bankAccountNumber}
        />
        <LabeledRow
          label="Transfer Amount"
          value={`${formatCurrency(Number.parseFloat(offerOrderTransferFunds.transferAmount))}`}
        />
        <div styleName="breakLineTotal" />
      </div>
    );
  }

  const sub = (
    <div>
      Your order will remain pending until the investment is accepted on the
      closing date. Due to demand and&nbsp;
      <Link
        styleName="disclaimerLink"
        to={`/invest/${offer.id}/other-factors`}
      >
        other factors
      </Link>
      &nbsp;it is possible your investment may not get accepted.
    </div>
  );

  return (
    <BaseConfirmationScreen
      onBackClick={async () => { await resetAll(); return true; }}
      backTo="/offers"
      backLabel="View available offers"
      confirmationText="Order Confirmed"
      header={`Order Confirmation ID: ${investmentInfo.confirmationId}`}
      subtext={sub}
    >
      <div styleName="reviewOrderHeader">
        {offer.name}
      </div>
      <div styleName="main">
        <LabeledRow
          label="Investor Name"
          value={`${user.identity.firstName} ${user.identity.lastName}`}
        />
        <LabeledRow
          label="Address"
          value={user.identity.primaryAddress.line1}
          modifiedStyle="addressRow"
        />
        <LabeledRow
          label=""
          value={`${user.identity.primaryAddress.city} ${user.identity.primaryAddress.state}, ${user.identity.primaryAddress.zipcode}`}
        />
        <LabeledRow
          label="Date"
          value={moment(investmentInfo.subscribed).format('ll')}
        />
        {
          isConditional ?
            <LabeledRow
              label="Offering Category"
              value={offer.categoryName}
            /> : null
        }
        {
          isConditional ?
            <LabeledRow
              label="Share Range"
              value={`${formatCurrency(offer.minSharePrice)} - ${formatCurrency(offer.maxSharePrice)}`}
            /> :
            <div>
              <LabeledRow
                label="Share Price"
                value={offer.pricePerShare}
                isCurrency
              />
              <LabeledRow
                label="Share Quantity"
                value={formatQuantity(Number.parseFloat(offerOrderAmount.quantity))}
              />
            </div>
        }
        { offerOrderTransferFunds.transferAmount ?
            transferDetails :
            <div styleName="breakLineTotal" />
        }
        <LabeledRow
          label="Total Investment"
          value={Number.parseFloat(offerOrderAmount.requestedDollarAmount)}
          isCurrency
        />
      </div>
    </BaseConfirmationScreen>
  );
};

Component.displayName = 'InvestmentConfirmation';

const mapStateToProps = (state, ownProps) => ({
  bankLinks: get(state, `accountBankLinks.[${state.currentAccount}].data`, []),
  investmentInfo: get(state, `investmentsByOffer[${ownProps.offer.id}]`),
  offerOrderAmount: get(state, offerOrderAmountPath),
  offerOrderTransferFunds: get(state, offerOrderTransferPath),
  user: state.user.data,
});

const mapDispatchToProps = dispatch => ({
  navigateTo: (...args) => (dispatch(navigate(...args))),
  resetAll: async () => {
    await dispatch(actions.reset(baseOfferOrderPath));
    await dispatch(actions.reset(offerOrderAmountPath));
    await dispatch(actions.reset(offerOrderDisclosuresPath));
    await dispatch(actions.reset(offerOrderTransferPath));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/Invest/InvestmentViews/InvestmentConfirmation.js